module.exports = __webpack_public_path__ + "img/angola-logo-icon.e7dfc9f4.png";